export const resumes = [
    {
        name: 'Resume',
        pdfLink: '/resume/Resume.pdf'
    },
]